import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import TopMarquee from "@/components/Marquee";
import OfferBanner from "@/components/OfferBanner";
import CartDrawer from "@/components/CartDrawer";
import ApiStatusBanner from "@/components/ApiStatusBanner";
import MobileCategoryTabs from "@/components/MobileCategoryTabs";
import { prefetchAllCategoriesOnIdle } from "@/lib/categoryPrefetch";
import RouteSeo from "@/components/RouteSeo";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Layout = () => {
  useEffect(() => {
    prefetchAllCategoriesOnIdle();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <RouteSeo />
      <TopMarquee />
      <OfferBanner />
      <ApiStatusBanner />
      <Header />
      <MobileCategoryTabs />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <WhatsAppFloat />
    </div>
  );
};

export default Layout;
